export const UploadIconName = 'pi pi-upload';
export const DownloadIconName = 'pi pi-download';
export const FileIconName = 'pi pi-file-o';
export const ArchiveIconName = 'pi pi-trash';
export const ReleaseIconName = 'pi pi-lock-open';
export const SendIconName = 'pi pi-envelope';
export const ExcelIconName = 'pi pi-file-excel';
export const GotoIconName = 'pi pi-compass';

export const FileTypeNames: string[] = [
    'Unknown',
    'Gas',
    'Electric',
    'Water',
    'BAPA',
    'Telecoms',
    'LSBUD',
    'Document'
];

export const FileStatusNames: string[] = [
    'None',
    'New',
    'Valid',
    'Archived',
    'Expired',
    'Error'
];

export const FluidityTaskTexts: string[] = [
    'Unknown.',
    'Agree Supervision date for works to proceed.',
    'Upload completed SSR Document.',
    'Release works as ok to proceed.',
    'Email for approval sent to Asset owner'
];

export const DigStatusNames: string[] = [
    'Unknown',
    'Wait for Safe Dig',
    'Wait for Hot Job',
    'Released',
    'Complete',
    'Wait for Reply',
    'Cancelled'
];

export const AuditLogEntryNames: string[] = [
    'New Safedig',
    'Update Safedig',
    'Delete Safedig',
    'New Safedig File',
    'Update Safedig File',
    'Delete Safedig File',
    'New Safedig Task',
    'Update Safedig Task',
    'Delete Safedig Task',
    'Update Supervison Date',
    'Released Job',
    'Release Quarantine',
    'Make Hot Job',
    'Remove Hot Job',
    'Archive File',
    'Add Note',
    'Quarantine',
    'Closed Job',
    'Email Sent',
    'Email Complete'
];

export const JobAreas: string[] =[
    'Aintree',
    'Ashford',
    'Canterbury',
    'Barrow/Dalton',
    'Lancaster',
    'Stoneycroft',
    'Sefton Park',
    'Service Delivery',
    'Other'
]